import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";
import NtMaterialIcon from "../../../components/NtMaterialIcon";

function NtBusinessMemberSection(props) {
  const renderBox = (containerStyle, number, icon, text) => {
    return (
      <View
        style={[
          {
            flex: 1,
            borderRadius: 10,
            backgroundColor: "#181818",
            padding: 20,
          },
          containerStyle,
        ]}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtText
            style={{ flex: 1, color: "white", fontSize: 30, fontWeight: "600" }}
          >
            {number}
          </NtText>
          <NtMaterialIcon name={icon} size={35} color="#12ABFF" />
        </View>
        <NtText
          style={{
            color: "white",
            fontSize: 14,
            fontWeight: "500",
            marginTop: 40,
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle>BECOME A MEMBER IN 3 STEPS</NtSectionTitle>
      <NtSectionDescription
        style={{
          marginTop: 8,
          textAlign: "center",
        }}
      >
        A powerful suite of features including Ring Groups, Call Recording,
        Advanced Call Forwarding, and Extensions—designed to streamline
        communication,{" "}
      </NtSectionDescription>

      <View style={{ marginTop: 40, flexDirection: "row" }}>
        {renderBox(
          { marginRight: 10 },
          "01",
          "cog",
          "Choose a setup option based on the size of your business"
        )}
        {renderBox(
          { marginRight: 10 },
          "02",
          "notebook-outline",
          "Create your perfect plan"
        )}
        {renderBox(
          { marginRight: 10 },
          "03",
          "tools",
          "Configure your service"
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtBusinessMemberSection;
